import { config } from "core/config/app";
import ImageRecipesLoadingPage from "./pages/ImageRecipesLoadingPage";
import ImageRecipesPage from "./pages/ImageRecipesPage";
import ImageIngredientsLoadingPage from "./pages/ImageIngredientsLoadingPage";
import ImageIngredientsPage from "./pages/ImageIngredientsPage";
import RecipeDetailPage from "modules/Recipes/pages/RecipeDetailPage";

const router = [
  {
    name: "AI_CHEF_RECIPE_LOADING",
    auth: true,
    exact: true,
    path: `${config?.basename}/ai-chef/recipe/loading`,
    element: <ImageRecipesLoadingPage />,
    title: "Take a photo and analysis loading "
  },
  {
    name: "AI_CHEF_RECIPES",
    auth: true,
    exact: true,
    path: `${config?.basename}/ai-chef/recipes`,
    element: <ImageRecipesPage />,
    title: "Recipes analysis"
  },
  {
    name: "AI_CHEF_INGREDIENT_LOADING",
    auth: true,
    exact: true,
    path: `${config?.basename}/ai-chef/ingredient/loading`,
    element: <ImageIngredientsLoadingPage />,
    title: "Ingredients analysis loading",
  },
  {
    name: "AI_CHEF_INGREDIENTS",
    auth: true,
    exact: true,
    path: `${config?.basename}/ai-chef/ingredients`,
    element: <ImageIngredientsPage />,
    title: "Ingredients analysis and lising "
  },
  {
    name: "AI_CHEF_RECIPE_DETAIL",
    auth: true,
    exact: true,
    path: `${config?.basename}/ai-chef/recipe/:id`,
    element: <RecipeDetailPage activeIndex={3} />,
    title: "Detailed Recipe analysis"
  },
];

export default router;
